/** @jsx jsx */
import { Box, Container, Grid } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";
import { TimeReport } from "@/data/time-reports";
import {
  TimeReportSummaryGeneralInformation,
  TimeReportSummaryHiringManager,
  TimeReportSummaryProjects,
} from "@/views/time-reports/summary";

interface TimeReportDetailsSummaryTabProps {
  timeReport: TimeReport;
}

export const TimeReportDetailsSummaryTab: FC<TimeReportDetailsSummaryTabProps> = ({ timeReport }) => {
  return (
    <Container>
      <Grid columns={["1fr", null, null, "1fr 2fr"]} gap={["xs", null, null, "sm"]} sx={{ alignItems: "start" }}>
        <Grid gap={["xs", null, null, "sm"]}>
          <TimeReportSummaryGeneralInformation timeReport={timeReport} />
          <TimeReportSummaryHiringManager timeReport={timeReport} />
        </Grid>

        <Box data-name="Box" sx={{ maxWidth: "100vw" }}>
          <ResponsiveCard sx={{ p: ["sm", null, null, "md"] }}>
            <TimeReportSummaryProjects timeReport={timeReport} />
          </ResponsiveCard>
        </Box>
      </Grid>
    </Container>
  );
};
